import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState({ state: "checking", data: null });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus({ state: "error", data: null }); return; }

    let cancelled = false;
    const poll = async (n) => {
      if (cancelled) return;
      if (n >= 8) { setStatus({ state: "timeout", data: null }); return; }
      try {
        const { data } = await api.get(`/checkout/status/${sid}`);
        if (data.payment_status === "paid") { setStatus({ state: "paid", data }); return; }
        if (data.status === "expired") { setStatus({ state: "expired", data }); return; }
        setAttempts(n + 1);
        setTimeout(() => poll(n + 1), 2000);
      } catch {
        setStatus({ state: "error", data: null });
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, [params]);

  return (
    <div className="min-h-screen grid place-items-center bg-white text-zinc-900 grid-bg" data-testid="checkout-success-page">
      <div className="rounded-3xl border border-black/5 bg-white border border-black/5 shadow-sm p-10 max-w-md w-full text-center">
        {status.state === "checking" && (
          <>
            <div className="mx-auto h-10 w-10 rounded-full border-2 border-violet-500 border-t-transparent animate-spin" />
            <h2 className="mt-4 font-display text-2xl font-bold">Verifying payment…</h2>
            <p className="mt-2 text-sm text-zinc-500">Attempt {attempts + 1} of 8</p>
          </>
        )}
        {status.state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" />
            <h2 className="mt-4 font-display text-2xl font-bold">Payment successful</h2>
            <p className="mt-2 text-sm text-zinc-500">AI is already activating your new capabilities.</p>
            <button onClick={() => nav("/dashboard")} className="mt-6 rounded-full ashra-gradient-bg px-5 py-2.5 text-sm font-medium" data-testid="success-back">Back to Command Center</button>
          </>
        )}
        {(status.state === "timeout" || status.state === "error" || status.state === "expired") && (
          <>
            <XCircle className="mx-auto h-12 w-12 text-rose-400" />
            <h2 className="mt-4 font-display text-2xl font-bold">Couldn't verify</h2>
            <p className="mt-2 text-sm text-zinc-500">Check your email or try again.</p>
            <button onClick={() => nav("/billing")} className="mt-6 rounded-full bg-zinc-100 px-5 py-2.5 text-sm">Back to billing</button>
          </>
        )}
      </div>
    </div>
  );
}
